module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clubs"
  }, [_c('el-form', {
    ref: "clubData",
    staticClass: "edit-club-form",
    attrs: {
      "model": _vm.clubData,
      "rules": _vm.validators,
      "label-width": "200px"
    }
  }, [(_vm.userIsSuperAdmin) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Client",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Client"
    },
    model: {
      value: (_vm.clubData.client_id),
      callback: function($$v) {
        _vm.$set(_vm.clubData, "client_id", $$v)
      },
      expression: "clubData.client_id"
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('div', {
      key: client.id
    }, [_c('el-option', {
      attrs: {
        "label": client.name,
        "value": String(client.id)
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clubData.name),
      callback: function($$v) {
        _vm.$set(_vm.clubData, "name", $$v)
      },
      expression: "clubData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Primary Contact Name",
      "prop": "primary_contact_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clubData.primary_contact_name),
      callback: function($$v) {
        _vm.$set(_vm.clubData, "primary_contact_name", $$v)
      },
      expression: "clubData.primary_contact_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Primary Contact Number",
      "prop": "primary_contact_number"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clubData.primary_contact_number),
      callback: function($$v) {
        _vm.$set(_vm.clubData, "primary_contact_number", $$v)
      },
      expression: "clubData.primary_contact_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('clubData')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7486cee4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clubs/ClubForm.vue
// module id = 925
// module chunks = 13